import { Component, Injector, OnInit } from '@angular/core';
import {mergeMap} from 'rxjs/operators';
import { CashCloseMovementTotal, CashCloseTicketData } from 'src/app/classes/CashCloseTicketBuilder';
import {CashCloseInfo, PaymentInfo, ReturnsInfo} from 'src/app/models/models';
import {Bank_Movement, Billing_Data, Withdrawal, Currency_Rate, Payment, Store} from 'src/app/models/RestModels';
import { CashCloseReportService, groupCashCountReferences } from 'src/app/services/cash-close-report.service';
import { PrinterService } from 'src/app/services/printer.service';
import {BaseComponent} from '../base/base.component';

@Component({
	selector: 'app-print-cash-closing2',
	templateUrl: './print-cash-closing2.component.html',
	styleUrls: ['./print-cash-closing2.component.css']
})

export class PrintCashClosing2Component extends BaseComponent implements OnInit
{
	cash_close_info:CashCloseInfo = null;
	current_date:Date = new Date();

	total_sales:number			= 0;
	total_credit:number			= 0;
	total_order_discount:number = 0;
	total_item_discount:number = 0;
	item_total:number			= 0;
	currencies_total:number		= 0;
	total_income_sales:number	= 0;
	total_income_other:number	= 0;
	total_order_amount_paid:number = 0;
	order_counter:number		= 0;
	total_caja:number			= 0;
	total_funds:number			= 0;
	total_expenses				= 0;
	total_withdrawals			= 0;
	withdrawals:Withdrawal[] = [];
	expenses_paymens:Payment[] = [];
	print_and_close:boolean = false;
	print_listener = ()=>{ window.close() };

	returns_info_list: ReturnsInfo[] = [];
	total_returns: number = 0;
	total_change_amount: number = 0;
	payments_with_change: Payment[] = [];

	cash_count_mxn_bills = [];
	cash_count_usd_bills = [];
	cash_count_mxn_coins = [];
	cash_count_usd_coins = [];

	currency_rate:Currency_Rate = {
		id: 0,
		rate: 19,
		store_id: 0,
		currency_id: 'USD'
	}
	movements_qtys:Record<string,CashCloseMovementTotal> = {
		'Efectivo':{ total: 0, currency_id:'MXN', equivalencia: 0 },
		'Dolares':{ total: 0, currency_id:'USD', equivalencia: 0 },
		'Tarjeta Crédito':{ total: 0, currency_id:'MXN', equivalencia: 0 },
		'Tarjeta Débito':{ total: 0, currency_id:'MXN', equivalencia: 0 },
		Transferencia:{ total: 0, currency_id:'MXN', equivalencia: 0 },
		Cheque:{ total: 0, currency_id:'MXN', equivalencia: 0 }
	};

	expense_movements_qtys:Record<string,CashCloseMovementTotal> = {};

	payment_movements:Bank_Movement[] = [];

	d: number = Math.random();
	billing_data: Billing_Data | null = null;
	store: Store;
	payment_info_list: PaymentInfo[] = [];
	diferencia_caja: number = 0;
	total_in_caja: number = 0;
	show_negative_warning: boolean = false;
	usb_enabled: boolean = false;

	private printerService: PrinterService;
	private cashCloseReport: CashCloseReportService;

	constructor(public injector: Injector) {
		super(injector);
		this.printerService = injector.get(PrinterService);
		this.cashCloseReport = injector.get(CashCloseReportService);
	}

	ngOnInit(): void
	{
		this.printerService.resolvePreferences(this.rest.current_user);
		this.usb_enabled = this.printerService.isUsbPrintingEnabled();

		this.subs.sink = this.route.paramMap.pipe
		(
			mergeMap((paramMap)=>
			{
				this.print_and_close = paramMap.has('print') && paramMap.get('print') == '1';
				return this.cashCloseReport.getReport( paramMap.get('id') )
			})
		)
		.subscribe((report)=>
		{
			this.cash_close_info = report.inputs.cash_close_info;
			this.billing_data = report.inputs.billing_data;
			this.payment_info_list = report.inputs.payment_info_list;
			this.returns_info_list = report.inputs.returns_info_list;
			this.store = report.inputs.store;
			this.current_date = report.inputs.current_date;
			// Every total below is computed by CashCloseReportService so the
			// browser receipt and the USB receipt share one source of truth.
			Object.assign(this, report.totals);

			if( this.print_and_close)
			{
				//this.rest.logout( false );
				setTimeout(()=>{
					console.log('Printing',this.d );
					window.print();
					//this.rest.logout(false);
					//window.close();
				},500);
			}
		},(error)=>this.showError(error));
	}

	closeSesion()
	{
		this.rest.logout(false);
		window.removeEventListener('afterprint',this.closeSesion);
	}

	printDirect()
	{
		window.print();
	}

	async printUsb(evt: Event): Promise<void>
	{
		try
		{
			if (this.printerService.available_printers.length === 0)
			{
				const storeId = this.cash_close_info?.store?.id;
				if (storeId)
				{
					const response = await this.rest.printer.search({
						limit: 9999,
						eq: { store_id: storeId },
						sort_order: ['name_ASC']
					}).toPromise();
					this.printerService.available_printers = response.data;
				}
			}

			// Seed from the user's server-side printer when this device has none
			this.printerService.resolvePreferences(this.rest.current_user);

			if (!this.printerService.isUsbPrintingEnabled())
			{
				this.showError('No hay impresora USB configurada. Configure la impresora en ajustes.');
				return;
			}

			const result = await this.printerService.printCashClose(this.buildCashCloseTicketData(), 1, evt);

			if (!result.success)
			{
				this.showError('Error al imprimir: ' + result.message);
				return;
			}

			this.showSuccess('Corte impreso correctamente');
		}
		catch (error: any)
		{
			console.error('USB print error:', error);
			this.showError('Error al imprimir: ' + (error?.message || 'Error desconocido'));
		}
	}

	buildCashCloseTicketData(): CashCloseTicketData
	{
		return {
			store: this.store,
			billing_data: this.billing_data,
			user_name: this.cash_close_info?.user?.name || '',
			current_date: this.current_date,
			start: this.cash_close_info.cash_close.start,
			end: this.cash_close_info.cash_close.end,
			note: this.cash_close_info.cash_close.note,
			total_sales: this.total_sales,
			total_credit: this.total_credit,
			total_order_discount: this.total_order_discount,
			total_item_discount: this.total_item_discount,
			total_income_sales: this.total_income_sales,
			total_income_other: this.total_income_other,
			total_expenses: this.total_expenses,
			total_expenses_all: this.getExpensesTotal(),
			total_withdrawals: this.total_withdrawals,
			total_returns: this.total_returns,
			total_funds: this.total_funds,
			total_in_caja: this.total_in_caja,
			cash_on_hand: this.cash_close_info.cash_close.cash_on_hand,
			diferencia_caja: this.diferencia_caja,
			currencies_total: this.currencies_total,
			usd_rate: this.currency_rate.rate,
			funds: this.cash_close_info.funds,
			withdrawals: this.withdrawals,
			expense_movements_qtys: this.expense_movements_qtys,
			movements_qtys: this.movements_qtys,
			references: this.getCashCountReferences(),
			mxn_bills: this.cash_count_mxn_bills,
			usd_bills: this.cash_count_usd_bills,
			mxn_coins: this.cash_count_mxn_coins,
			usd_coins: this.cash_count_usd_coins,
			show_negative_warning: this.show_negative_warning
		};
	}

	getCashCountTotal(arr: any[]): number
	{
		return arr.reduce((sum, item) => sum + (item.denomination * item.quantity), 0);
	}

	getExpensesTotal(): number
	{
		return Object.keys(this.expense_movements_qtys).reduce((sum, key) =>
		{
			return sum + (this.expense_movements_qtys[key].total || 0);
		}, 0);
	}

	getCashCountReferences(): { type: string; total: number; currency_id: string }[]
	{
		return groupCashCountReferences(this.cash_close_info?.cash_counts);
	}

}
